interface NameParts {
  displayName?: string | null;
  user?: { firstName?: string | null; lastName?: string | null } | null;
}

type NamedMember = NameParts | null | undefined;

export function memberRealName(membership: NamedMember): string {
  return [membership?.user?.firstName, membership?.user?.lastName].filter(Boolean).join(" ").trim();
}

export function memberName(membership: NamedMember, fallback = "Teammate"): string {
  const displayName = membership?.displayName?.trim();
  if (displayName) {
    return displayName;
  }
  return memberRealName(membership) || fallback;
}

export function memberFirstName(membership: NamedMember, fallback = "Teammate"): string {
  const displayName = membership?.displayName?.trim();
  if (displayName) {
    return displayName;
  }
  return membership?.user?.firstName?.trim() || fallback;
}
